import { render, staticRenderFns } from "./PillBadge.vue?vue&type=template&id=6753393d&"
import script from "./PillBadge.vue?vue&type=script&lang=js&"
export * from "./PillBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports